import { clsx, type ClassValue } from "clsx";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const item = {
  hidden: { y: 20, opacity: 0 },
  show: { y: 0, opacity: 1 },
};

export const getVisitTitle = (
  title: string | undefined,
  rowno: number
): string => {
  return title ? title : `${t("visits.visit")} #${rowno}`;
};

export const formatTitle = (title: string = ""): string =>
  title ? `${title}. ` : "";

export const stripMarkdown = (md: string): string => {
  return (
    md
      .replace(/\*\*(.*?)\*\*/g, "$1") // bold **text**
      .replace(/\*(.*?)\*/g, "$1") // italics *text*
      .replace(/__(.*?)__/g, "$1") // underline __text__
      .replace(/_(.*?)_/g, "$1") // italics _text_
      .replace(/`([^`]+)`/g, "$1") // inline code `text`
      .replace(/#+\s?(.*)/g, "$1") // headings # H1
      .replace(/!\[.*?\]\(.*?\)/g, "") // images ![alt](url)
      .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1") // links [text](url)
      .replace(/>\s?(.*)/g, "$1") // blockquotes > text
      // .replace(/-\s/g, "") // dash lists (e.g., "- item")
      .replace(/\*\s/g, "") // asterisk lists (e.g., "* item")
      .replace(/\+\s/g, "") // plus sign lists (e.g., "+ item")
      .replace(/\r?\n|\r/g, "\n") // line breaks
      .trim()
  );
};

export const bytesToMegabytes = (bytes: number): number => {
  return bytes / (1024 * 1024);
};
